import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
	getHolidayList, 
	doHolidayDelete,
	doHolidayReset,
} from "../../../../redux/holiday/holidayState";
import { displayIcon } from "variables/icons";
import dayjs from "dayjs";
import { Calendar } from "antd";
import Button from "components/button";
import Card from "components/card";
const MIN_YEAR = 2026;

const HolidayCalendar = ({ }) => {

	const dispatch = useDispatch();
	const recordList = useSelector((state) => state.holiday.holidayList?.items);
	const pagination = useSelector((state) => state.holiday.holidayList?.pagination);
	const filters = useSelector((state) => state.holiday.holidayList?.filters);
	console.log('holidayList', recordList);
	const doSearch = (filters) => dispatch(getHolidayList(filters));
	const doDelete = (id) => dispatch(doHolidayDelete(id));
	const doRecordReset = () => dispatch(doHolidayReset());

	const [selectedYear, setSelectedYear] = useState(
        Math.max(dayjs().year(), MIN_YEAR)
    );

    const months = Array.from({ length: 12 }, (_, index) =>
        dayjs()
            .year(selectedYear)
            .month(index)
            .startOf("month")
    );

    const previousYear = () => {
        setSelectedYear((year) => Math.max(MIN_YEAR, year - 1));
    };

    const nextYear = () => {
        setSelectedYear((year) => year + 1);
    };
	
	useEffect(() => {
		dispatch(getHolidayList({ paginate: 10 }));
	}, [dispatch]);

  	return (
		<Card extra={"w-full h-full p-4"}>
			<div className="space-y-2 mb-4">
				<div className="flex items-center justify-center gap-6">
					<button
						type="button"
						onClick={previousYear}
						disabled={selectedYear <= MIN_YEAR}
						className="rounded-lg p-2 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-30 dark:hover:bg-slate-700"
					>
						{displayIcon("ChevronLeft", "icon-item muted-text")}
					</button>
					<span className="min-w-[80px] text-center text-lg font-semibold title-text">
						{selectedYear} Holidays
					</span>

					<button
						type="button"
						onClick={nextYear}
						className="rounded-lg p-2 transition hover:bg-slate-100 dark:hover:bg-slate-700"
					>
						{displayIcon("ChevronRight", "icon-item muted-text")}
					</button>
				</div>
				<div className="flex items-center justify-center gap-6">
					<Button
						size="sm"
						className="btn-gradient-emerald h-6 w-38 rounded-xl text-sm mt-4 shadow-lg hover:shadow-lg font-medium"
					>
						Generate Holidays
					</Button>
				</div>
			</div>


			<div className="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{months.map((month) => (
					<div
						key={month.month()}
						className="
							rounded-lg border border-slate-200 bg-white p-1
							dark:border-slate-700 dark:bg-slate-800
							[&_.ant-picker-calendar-date-value]:text-[12px]
							[&_.ant-picker-calendar-date-value]:leading-6
							[&_.ant-picker-content_th]:p-0
							[&_.ant-picker-content_th]:text-[12px]
							[&_.ant-picker-content_th]:font-medium
							[&_.ant-picker-content_td]:p-0
						"
					>
						<Calendar
							value={month}
							fullscreen={false}
							disabledDate={(date) => !date.isSame(month, "month")}
							headerRender={() => (
								<div className="w-full rounded-t-md bg-blue-100 px-2 py-1 text-center text-sm font-semibold title-text dark:bg-blue-800">
									{month.format("MMMM YYYY")}
								</div>
							)}
						/>
					</div>
				))}
			</div>
		</Card>

  );
};

export default HolidayCalendar;
